import { i18n } from '@/i18n'
import adminRoutes from './admin'
import loginRoutes from './login'
import { beforeFun } from './person'

export default function() {
  return [
    {
      path: '/not_registry',
      name: 'notRegistry',
      meta: { title: i18n.t('nav.registry') },
      beforeEnter: beforeFun,
      isShow() {
        return false
      },
      component: () => import(/* webpackChunkName: "notRegistry" */ '@/views/notRegistry/index'),
    },
    {
      path: '/guide',
      name: 'guidePage',
      isShow() {
        return false
      },
      component: () => import(/* webpackChunkName: "guidePage" */ '@/views/guide/index'),
      meta: { title: '平台指引' },
    },

    ...loginRoutes(),
    ...adminRoutes,
  ]
}
